var getOS = function getOS(agent) {
  var _agent$toLocaleLowerC;
  var userAgent = (_agent$toLocaleLowerC = agent === null || agent === void 0 ? void 0 : agent.toLocaleLowerCase()) !== null && _agent$toLocaleLowerC !== void 0 ? _agent$toLocaleLowerC : navigator.userAgent.toLocaleLowerCase();
  if (!userAgent) {
    return 'Unknown OS';
  }
  switch (true) {
    case userAgent.indexOf('mac') > -1:
      return 'MacOS';
    case userAgent.indexOf('win') > -1:
      return 'Windows';
    case userAgent.indexOf('linux') > -1:
      return 'Linux';
    default:
      return 'Unknown OS';
  }
};

export { getOS as default };
//# sourceMappingURL=index.js.map
